import { render, staticRenderFns } from "./HomeCyAiTab.vue?vue&type=template&id=1809ed70&scoped=true"
import script from "./HomeCyAiTab.vue?vue&type=script&lang=js"
export * from "./HomeCyAiTab.vue?vue&type=script&lang=js"
import style0 from "./HomeCyAiTab.vue?vue&type=style&index=0&id=1809ed70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1809ed70",
  null
  
)

export default component.exports